angular.module 'app'
.controller 'AddNewsCtrl', ($scope, $http, $stateParams, $state, config, Storage, dialogs, growl, SweetAlert, FileUploader,ueditorConfig) ->

  $scope.ui =
    resourcesUrl: config.resources.baseUrl
    country: if Storage.get('login_user').meta.country then Storage.get('login_user').meta.country else 'World Internet Project'
    title: ''
    digest: ''
    uploadImg: ''
    figurefile: {},
    thumb_url: ''
    link: ''
    menutype: 'News'
    is_file: false
    isLoading: false
    uploadFile: false
    fileLinkInput: false
    fileLink: 'nothing'
    config:
      wordCount: false
      maximumWords: 20000
      wordCountMsg: '&nbsp;當前您已輸入&nbsp;{#count}&nbsp;個字符。'
      elementPathEnabled: false
      autoHeightEnabled: false
      autoFloatEnabled: false
      autoTransWordToList: true
      imagePopup: true
      insertorderedlist:
        'decimal': ''
        'lower-alpha': ''
        'lower-roman': ''
        'upper-alpha': ''
        'upper-roman': ''
      insertunorderedlist:
        circle: ''
        disc: ''
        square: ''
      lang: "en"
      initialFrameHeight: angular.element('#graphic-detail').height() - 100
      toolbars: ueditorConfig.ue.config.toolbars
    date: moment().format('YYYY-MM-DD HH:mm:ss')
    opts:
      autoApply: true
      parentEl: 'div#view-fans-message'
      minDate: moment().format('YYYY-MM-DD HH:mm:ss')
      opens: 'center'
      timePicker: true
      timePicker24Hour: true
      timePickerSeconds: true
      singleDatePicker: true
      locale:
        format: 'YYYY-MM-DD HH:mm:ss'
        applyLabel: '應用'
        cancelLabel: '取消'
        daysOfWeek: ['日', '一', '二', '三', '四', '五','六']
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']

  $scope.$on '$destroy', ->
    editor = UE.getEditor 'uecontainer'
    editor.destroy()

  ### 获取编辑器模板 ###
  _.defer ->
    $scope.ui.config.initialFrameHeight = angular.element('#graphic-detail').height()
    uex('uecontainer', ->
      $http.get "#{config.api.baseUrl}/ueditor/group?access_token=" + Storage.get('access_token'), {}
      .then (res) ->
        setTemplate('uecontainer', res.data.data)
      .catch (error) ->
        if error.data.error.indexOf('errtext') >= 0
          err = JSON.parse error.data.error
          growl.error err.errtext
        else
          growl.error('網絡連接失敗，請稍後重試')
    )

  # 設置日曆
  $scope.ui.opts.parentEl = 'div#activity-modal'
  $scope.ui.opts.opens = 'right'
  delete $scope.ui.opts.maxDate

  # 上傳文件
  uploaderFile = $scope.uploaderFile = new FileUploader(
    autoUpload: true
    removeAfterUpload: true
    url: "#{config.api.baseUrl}/filemanage/file/upload_file?access_token=#{Storage.get('access_token')}&type=#{$scope.ui.menutype}&user_id=#{Storage.get('login_user').id}"
  )

  uploaderFile.onBeforeUploadItem = (item) ->

  uploaderFile.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.ui.figurefile = response.file
    growl.success("Upload success!")

  #傳圖片
  uploaderFile.onErrorItem = (fileItem, response, status, headers) ->
    growl.error("Upload failed!")

  #傳圖片
  uploaderImage = $scope.uploaderImage = new FileUploader(
    autoUpload: true
    removeAfterUpload: true
    url: "#{config.api.baseUrl}/filemanage/file/upload_thumb?access_token=#{Storage.get('access_token')}&type=#{$scope.ui.menutype}&user_id=#{Storage.get('login_user').id}"
  )

  uploaderImage.onBeforeUploadItem = (item) ->

  uploaderImage.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.ui.thumb_url = response.thumb_url
    growl.success("Upload success!")


  uploaderImage.onErrorItem = (fileItem, response, status, headers) ->
    growl.error("Upload failed!")


  # 通过_id查找到相关数据
  findData = ->
    $http.get "#{config.api.baseUrl}/filemanage/file/#{$stateParams._id}?access_token=" + Storage.get('access_token'),
      params: {}
    .then (res) ->
      $scope.ui.title = res.data.title
      $scope.ui.country = res.data.country
      $scope.ui.figurefile = res.data.file
      $scope.ui.thumb_url = res.data.thumb_url
      $scope.ui.digest = res.data.digest
      $scope.ui.link = res.data.link
      $scope.ui.is_file = res.data.is_file
      $scope.ui.fileLink = if res.data.is_file is true then 'uploadFile' else 'fileLink'

  ### 初始化 ###
  if $stateParams._id
    findData()

  #附件類型選擇
  $scope.selectFileType = ->
    if $scope.ui.fileLink == 'uploadFile'
      $scope.ui.uploadFile = true
      $scope.ui.fileLinkInput = false
      $scope.ui.is_file = true
    else
      $scope.ui.fileLinkInput = true
      $scope.ui.uploadFile = false
      $scope.ui.is_file = false

  #保存
  $scope.save = ->
    return growl.error 'Title can not be empty!' if $scope.ui.title == ''
    return growl.error 'Please upload Attachment!' if $scope.ui.is_file and !$scope.ui.figurefile.path
    if $stateParams._id
      obj =
        title: $scope.ui.title
        digest: $scope.ui.digest
        thumb_url: $scope.ui.thumb_url
        country: $scope.ui.country
        link: $scope.ui.link
        is_file: $scope.ui.is_file
        created_at: moment($scope.ui.date).format('YYYY-MM-DD HH:mm:ss')
      obj.is_nothing = if $scope.ui.fileLink is 'nothing' then true else false
      $http.put "#{config.api.baseUrl}/filemanage/file/#{$stateParams._id}?access_token=" + Storage.get('access_token'), obj
      .then (res) ->
        growl.success "Saved successfully!"
      .finally ->
        $scope.ui.isLoading = false
        $state.go('app.mediaNews')
      .catch (error) ->
        if error.data.error.indexOf('errtext') >= 0
          err = JSON.parse error.data.error
          growl.error err.errtext
        else
          growl.error('The network connection failed. Please try again later')
    else
      obj =
        type: $scope.ui.menutype
        user_id: Storage.get('login_user').id
        title: $scope.ui.title
        digest: $scope.ui.digest
        file: $scope.ui.figurefile
        country: $scope.ui.country
        thumb_url: $scope.ui.thumb_url
        link: $scope.ui.link
        is_file: $scope.ui.is_file
        created_at: moment($scope.ui.date).format('YYYY-MM-DD HH:mm:ss')
      obj.is_nothing = if $scope.ui.fileLink is 'nothing' then true else false
      $http.post "#{config.api.baseUrl}/filemanage/file/save/?access_token=" + Storage.get('access_token'), obj
      .then (res) ->
        growl.success "Saved successfully!"
      .finally ->
        $scope.ui.isLoading = false
        $state.go('app.mediaNews')
      .catch (error) ->
        if error.data.error.indexOf('errtext') >= 0
          err = JSON.parse error.data.error
          growl.error err.errtext
        else
          growl.error('The network connection failed. Please try again later')




